module.exports = __webpack_public_path__ + "static/media/play.3b1cd5fe.svg";